import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { EmployeeSummaryPreviewComponent } from './employee-summary-preview.component';

@NgModule({
  declarations: [
    EmployeeSummaryPreviewComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    EmployeeSummaryPreviewComponent
  ]
})
export class EmployeeSummaryPreviewModule { }
